exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":host {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  background: black;\r\n}\r\n\r\n.wistia-container {\r\n  position: relative;\r\n  top: 50%;\r\n  -webkit-transform: translateY(-50%);\r\n          transform: translateY(-50%);\r\n}", ""]);

